/**
 * components/landing/pricing/PricingPage.jsx — Phase 7 · Commercial
 * Decision Center orchestrator.  Composes the 13 pricing sections in
 * the narrative order defined in the PRD.
 */

import SiteFrame from '@/components/landing/SiteFrame'
import Hero          from './sections/Hero'
import Philosophy    from './sections/Philosophy'
import Plans         from './sections/Plans'
import Comparison    from './sections/Comparison'
import Included      from './sections/Included'
import ROI           from './sections/ROI'
import Timeline      from './sections/Timeline'
import Payment       from './sections/Payment'
import Terms         from './sections/Terms'
import Support       from './sections/Support'
import FAQ           from './sections/FAQ'
import ContactSales  from './sections/ContactSales'
import FinalCTA      from './sections/FinalCTA'

const PricingPage = () => (
  <SiteFrame hideFooterCta={true}>
    <Hero />
    <Philosophy />
    <Plans />
    <Comparison />
    <Included />
    <ROI />
    <Timeline />
    <Payment />
    <Terms />
    <Support />
    <FAQ />
    <ContactSales />
    <FinalCTA />
  </SiteFrame>
)

export default PricingPage
